import { useEffect } from 'react';

import { Box, Grow, Paper, Slide, Typography } from '@mui/material';

import { DelayedFade } from '@/components/common/DelayedFade';

import cleanTradeLogo from '@/assets/CleanTrade-logo-dark.png';

import { AuthGlobalStyles } from './AuthGlobalStyles';
import { LoginButton } from './LoginButton';

import {
  containerStyles,
  logoStyles,
  mainCardStyles,
  titleStyles,
} from './Login.styles';

export const Login = () => {
  useEffect(() => {
    const originalTitle = document.title;
    document.title = 'Login - CleanTrade';

    return () => {
      document.title = originalTitle;
    };
  }, []);

  return (
    <>
      <AuthGlobalStyles />
      <Box sx={containerStyles}>
        <Grow in timeout={800}>
          <Paper elevation={24} sx={mainCardStyles}>
            <Slide direction="down" in timeout={1000}>
              <Box
                component="img"
                src={cleanTradeLogo}
                alt="CleanTrade Logo"
                sx={logoStyles}
              />
            </Slide>

            <DelayedFade delay={400}>
              <Typography variant="h3" component="h1" sx={titleStyles}>
                Login to CleanTrade
              </Typography>
            </DelayedFade>

            <DelayedFade delay={800}>
              <LoginButton />
            </DelayedFade>
          </Paper>
        </Grow>
      </Box>
    </>
  );
};
